import { AudienceNode, isPartner } from '@/services/audienceService';
import { useTranslation } from '@/hooks/useTranslation';
import TreePicker, { TreePickerProps } from '@/components/ui/TreePicker';

export default function AudienceGroupPicker({ nodes, ...props }: Omit<TreePickerProps, 'nodes'> & { nodes: AudienceNode[] }) {
  const { t: { audience: c } } = useTranslation();
  return <TreePicker {...props} nodes={nodes.filter(node => !isPartner(node)).map(node => ({
    ...node, description: c.types[node.type],
  }))} />;
}
